import { z } from "zod";

import { OfferDiscountLikeObjectSchema } from "../../../../../dtos/offers";
import { PluginOfferProductSchema } from "../index";

export const PluginOfferDiscountSchema_2024_05_05 =
  OfferDiscountLikeObjectSchema.extend({
    // offerProducts: PluginOfferProductSchema.array().default([]),
  });

export type PluginOfferDiscountType_2024_05_05 = z.infer<
  typeof PluginOfferDiscountSchema_2024_05_05
>;
